import React from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import Fade from 'react-reveal/Fade';
import { CDN } from '../api';

const awards = [
  {
    image: `${CDN}/site/obie.PNG`,
    icon: 'trophy',
    title: '2024 Obie Award',
    body: 'Presented by the Greater Atlanta Home Builders Association — recognizing excellence in home building and design.',
    link: null,
  },
  {
    image: `${CDN}/site/mhb.png`,
    icon: 'book',
    title: 'Modern Home Builders Magazine',
    body: 'Featured in Modern Home Builders Magazine — Issue 144, 2025. A national spotlight on exceptional craftsmanship and custom design.',
    link: 'https://magazine.modernhb.com/ey2d/p72/p72?utm_source=Klaviyo&utm_medium=email&utm_campaign=MHB+magazine+-+144+-+Sept',
  },
];

function Awards() {
  return (
    <Box sx={{ backgroundColor: '#111', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Fade bottom>
          <Box textAlign="center" mb={8}>
            <Typography
              variant="overline"
              sx={{ color: '#FFA13C', letterSpacing: '0.2em', fontWeight: 600 }}
            >
              Recognition
            </Typography>
            <Typography
              variant="h3"
              sx={{
                color: '#f0f0f0',
                fontWeight: 700,
                mt: 1,
                fontSize: { xs: '1.8rem', md: '2.5rem' },
              }}
            >
              Award-Winning Craftsmanship
            </Typography>
          </Box>
        </Fade>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 6, md: 10 },
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {awards.map((award, i) => (
            <Fade bottom delay={i * 150} key={i}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: 'center',
                  gap: 4,
                  maxWidth: 680,
                  backgroundColor: '#161616',
                  border: '1px solid #2a2a2a',
                  borderRadius: 3,
                  p: { xs: 3, md: 5 },
                }}
              >
                <Box
                  sx={{
                    flexShrink: 0,
                    width: { xs: 140, sm: 180 },
                    height: { xs: 140, sm: 180 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#1e1e1e',
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  {award.image
                    ? <img src={award.image} alt={award.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    : <MenuBookIcon sx={{ fontSize: 72, color: '#FFA13C', opacity: 0.85 }} />
                  }
                </Box>
                <Box>
                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    {award.icon === 'book'
                      ? <MenuBookIcon sx={{ color: '#FFA13C', fontSize: 20 }} />
                      : <EmojiEventsIcon sx={{ color: '#FFA13C', fontSize: 20 }} />
                    }
                    <Typography
                      variant="overline"
                      sx={{ color: '#FFA13C', letterSpacing: '0.15em', fontWeight: 600 }}
                    >
                      {award.title}
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{ color: '#aaa', lineHeight: 1.8 }}
                  >
                    {award.body}
                  </Typography>
                  {award.link && (
                    <Typography
                      component="a"
                      href={award.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="body2"
                      sx={{
                        display: 'inline-block',
                        mt: 2,
                        color: '#FFA13C',
                        textDecoration: 'none',
                        fontWeight: 600,
                        letterSpacing: '0.04em',
                        '&:hover': { textDecoration: 'underline' },
                      }}
                    >
                      Read the Feature →
                    </Typography>
                  )}
                </Box>
              </Box>
            </Fade>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default Awards;
